module.exports = __webpack_public_path__ + "img/4.c5095662.png";